module.exports = __webpack_public_path__ + "img/SuperGoatLifeCredits.c789b844.png";